/** biome-ignore-all lint/a11y/useValidAriaRole: month-handler used for layout */
import React from "react";
import SvgIcon from "../../../../parts/SvgIcon";

export function MonthNavigator({ activeMonth, onMonthChange }) {
  return (
    <div role="month-handler">
      <div>
        <button type="button" onClick={() => onMonthChange(-1)}>
          <SvgIcon src="/img/new-icons/arrow-left.svg" alt="prev" />
        </button>
        <div className="labelMonth">{activeMonth.format("MMMM YYYY")}</div>
        <button type="button" onClick={() => onMonthChange(1)}>
          <SvgIcon src="/img/new-icons/arrow-right.svg" alt="next" />
        </button>
      </div>
    </div>
  );
}
